const {REACT_APP_APIS} = window._env_;

export {REACT_APP_APIS};